import React from "react"
import Typography from "components/Typography"
import { ProjectCardProps, ProjectDetail, ProjectStatus } from "../types"
import { TippyCustomzie } from "components/TippyCustomzie"
import {
  formatDate,
  formatDateForConversationMessage,
  getFirstLetterInName,
  showImageUrl,
} from "helpers/utils"
import { pushTo } from "helpers/history"
import { PATH } from "constants/path"
import { ReactComponent as IconFavorite } from "assets/images/icons/icon-favorite-project.svg"
import { ReactComponent as SecurityShieldIcon } from "assets/images/icons/icon-shield-security.svg"
import { ReactComponent as WarningEncryptIcon } from "assets/images/icons/warning-encrypt.svg"
import { ReactComponent as ProcessProjectIcon } from "assets/images/icons/process-project.svg"

import IconFavoriteActive from "assets/images/icons/icon-favorite.svg"
import StatusProject from "../molecules/StatusProject"
import { useBoolean } from "helpers/hooks"
import ActionItem from "../molecules/ActionItem"
import RoleUsersCard from "../molecules/RoleUsersCard"
import { Avatar } from "components/Avatar"
import { isUndefined } from "lodash"
import ActionIconHistory from "pages/project-component-detail/molecules/ActionIconHistory"
import Tippy from "@tippyjs/react"
import { toast } from "react-toastify"
import LabelNotificationPage from "components/Notification/LabelNotificationPage"
import { ReactComponent as IconMenuGroup } from "assets/images/icons/group-project.svg"
import { API_URL } from "config/environments"

const ProjectCard = (props: ProjectCardProps) => {
  const {
    item,
    isDiable,
    handleChangeButton,
    loggedUserId,
    openToNewTab,
    isSyncToOrganization,
    isCheckPermissionOrganization,
    isOrganization,
    isAddToGroup,
  } = props
  const showTippy = useBoolean(false)
  const isDeleted = item.status === ProjectStatus.DeletedAttachment
  const handleChangeRouter = () => {
    if (!item.id || isDeleted) {
      return
    }
    if (!isUndefined(item.is_moved) && item.is_moved) {
      toast(
        <LabelNotificationPage
          messenger={`This project is being moved to the organization!`}
          type="warning"
        />
      )
      return
    }
    if (item.sync_type) {
      toast(
        <LabelNotificationPage
          messenger={`This project is being synced to the organization!`}
          type="warning"
        />
      )
      return
    }

    if (openToNewTab) {
      window.open(`/project-detail/${item.id}`)
    } else
      pushTo(PATH.projectComponent, {
        idProject: item.id,
      })
  }

  const handleClickTippy = (event) => {
    event.stopPropagation()
    event.preventDefault()
    showTippy.setValue(!showTippy.value)
  }

  const onClickAction =
    (
      type:
        | "share"
        | "edit"
        | "archive"
        | "favorite"
        | "delete_attachment"
        | "sync_to_organization"
        | "move_to_organization"
        | "add_to_group"
        | "unassign_from_group",
      newItem: ProjectDetail
    ) =>
      (event) => {
        event.stopPropagation()
        event.preventDefault()
        if (isDiable || isDeleted || newItem.sync_type) {
          return
        }

        handleChangeButton(type, newItem, () => {
          showTippy.setValue(false)
        })
      }
  const urlAvatar = (newUrl: string) => {
    if (!newUrl.includes("public/")) {
      return undefined
    }
    return API_URL
  }
  const renderRoleUser = () => {
    if (item.user && item.user?.id && isOrganization) {
      return (
        <div className="flex items-center">
          <span
            className="font-medium"
            style={{
              color: "#7A7A7A",
              fontSize: 12,
              lineHeight: "18px",
              marginRight: 4,
            }}
          >
            Owner:
          </span>
          <Avatar
            width="24px"
            height="24px"
            name={item.user.fullname}
            avatar={item.user.avatar}
            textcolor="white"
            contentsize="11px"
            justOneLetter={true}
          />
        </div>
      )
    }
    if (item.user && item.user?.id && isUndefined(item.role_users)) {
      return (
        <div className="flex items-center">
          <span
            className="font-medium"
            style={{
              color: "#7A7A7A",
              fontSize: 12,
              lineHeight: "18px",
              marginRight: 4,
            }}
          >
            Owner:
          </span>
          <Avatar
            width="24px"
            height="24px"
            name={item.user.fullname}
            avatar={item.user.avatar}
            textcolor="white"
            contentsize="11px"
            justOneLetter={true}
          />
        </div>
      )
    }
    return (
      <RoleUsersCard
        data={
          item.role_users?.filter((i) => i.user_id !== item.created_by) || []
        }
        max={3}
      />
    )
  }

  const renderActionProject = () => {
    if (item.is_archived !== 0 || isDeleted) {
      return null
    }
    return (
      <React.Fragment>
        {/* <ActionItem title="Share" onClick={onClickAction("share", item)} /> */}
        <ActionItem title="Edit" onClick={onClickAction("edit", item)} />
        {isAddToGroup && isOrganization ? (
          <>
            <ActionItem
              title="Assign groups & users"
              onClick={() => {
                pushTo(
                  PATH.assignToGroupPage,
                  {
                    projectId: item.id,
                  },
                  {
                    isProjectPage: true,
                  }
                )
              }}
            />
          </>
        ) : null}
        {isSyncToOrganization ? (
          <ActionItem
            title="Sync to workspace"
            onClick={() => {
              pushTo(PATH.syncToOrganization, {
                projectId: item.id,
              })
            }}
          />
        ) : null}
        {/* {isMoveToOrganization ? (
          <ActionItem
            title="Move to workspace"
            onClick={onClickAction("move_to_organization", item)}
          />
        ) : null} */}
      </React.Fragment>
    )
  }
  const nameStatusActionArchived =
    item.is_archived === 0 ? "Archive" : "Unarchive"
  const isArchived = isDeleted || item.is_archived
  const renderIconEncrypt = () => {
    let icon = (
      <SecurityShieldIcon
        style={{
          color: "#7A7A7A",
        }}
      />
    )
    let title = "This project is not encrypted yet"
    if (item.is_encrypted) {
      if (item.accepted) {
        icon = (
          <SecurityShieldIcon
            style={{
              color: isArchived ? "#7A7A7A" : "#2ba84d",
            }}
          />
        )
        title = "This project is securely encrypted"
      } else {
        icon = (
          <WarningEncryptIcon
            className={
              isArchived ? "warning-encrypt-disabled" : "warning-encrypt"
            }
          />
        )
        title = "Pending acceptance. Click to accept"
      }
    }
    if (item.sync_type) {
      icon = <ProcessProjectIcon />
      title = "This project is being synced to the workspace!"
    }
    return (
      <Tippy
        className="custom-tippy-menu-left"
        placement="top"
        content={
          <span
            className="hidden md:block font-normal"
            style={{
              fontSize: 13,
              lineHeight: "22px",
            }}
          >
            {title}
          </span>
        }
      >
        <div
          onClick={handleChangeRouter}
          style={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          {icon}
        </div>
      </Tippy>
    )
  }

  return (
    <div
      className={`rounded-md p-3 min-h-[246px] flex flex-col justify-between hover-project-card ${item.is_archived === 1 ? "archived-project bg-neutral3" : "bg-white"
        } ${isDeleted
          ? "bg-neutral3 bg-delete-element archived-project"
          : "cursor-pointer"
        }`}
      style={{
        border: "1px solid #E4E4E4",
      }}
    >
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center header-card">
          {/* {item.groupOrganization ? (
            <Tippy
              className="custom-tippy-menu-left flex-1"
              placement="bottom"
              content={
                <span className="font-normal text-[13px] leading-[22px]">
                  {item.groupOrganization.name}
                </span>
              }
              arrow={false}
            >
              <div
                className="flex items-center justify-center rounded px-2
               type-component-card mr-2 h-[22px] bg-[#333333]"
              >
                <p className="font-semibold text-white text-[10px] leading-[14px]">
                  {item.groupOrganization.code}
                </p>
              </div>
            </Tippy>
          ) : null} */}

          {!isDiable ? (
            <React.Fragment>
              {item.is_favorite ? (
                <img
                  src={IconFavoriteActive}
                  alt="icon"
                  className="mr-2"
                  style={{
                    width: 16,
                  }}
                  onClick={onClickAction("favorite", item)}
                />
              ) : (
                <IconFavorite
                  className="mr-2"
                  onClick={onClickAction("favorite", item)}
                />
              )}
            </React.Fragment>
          ) : null}

          <span
            className="font-medium"
            style={{
              fontSize: 12,
              lineHeight: "18px",
              color: "#7A7A7A",
            }}
          >
            {item?.code}
          </span>
        </div>
        <div className="flex justify-center items-center">
          {renderIconEncrypt()}

          {!isDeleted &&
            !isDiable &&
            !item.sync_type &&
            isCheckPermissionOrganization ? (
            <TippyCustomzie
              containerClass="component-card-menu"
              placement="bottom-end"
              interactive
              arrow={false}
              animation="scale"
              visible={showTippy.value}
              onClickOutside={() => showTippy.setValue(false)}
              content={
                <div
                  style={{
                    background: "#222222",
                    borderRadius: 4,
                    paddingTop: 8,
                    paddingBottom: 8,
                    width: 165,
                  }}
                >
                  {renderActionProject()}

                  <ActionItem
                    title={nameStatusActionArchived}
                    onClick={onClickAction("archive", item)}
                  />
                  {loggedUserId === item.created_by ? (
                    <ActionItem
                      className="hidden md:flex"
                      title={"Delete"}
                      onClick={onClickAction("delete_attachment", item)}
                    />
                  ) : null}
                </div>
              }
              allowHTML
            >
              <div className="flex items-center" onClick={handleClickTippy}>
                <ActionIconHistory
                  icon="three-dots"
                  tooltip="Action"
                  styleIcon={{
                    marginRight: 0,
                  }}
                />
              </div>
            </TippyCustomzie>
          ) : (
            <div />
          )}
        </div>
      </div>

      <div className="flex flex-1 flex-col" onClick={handleChangeRouter}>
        <div className="flex items-center status-title-card">
          <StatusProject
            status={item.is_archived ? ProjectStatus.Archive : item.status || 4}
          />
          <p
            className="font-semibold name-card"
            style={{
              color: "#111111",
              fontSize: 14,
              lineHeight: "24px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {item?.name}
          </p>
        </div>

        <div className="h-42 mt-3 description-project-card">
          <Typography
            style={{
              color: "#111111",
              fontSize: 13,
              lineHeight: "22px",
            }}
            textClass="line-two-text whitespace-pre-line font-normal"
          >
            {item?.description}
          </Typography>
        </div>

        <div className="flex flex-1 flex-col justify-between">
          <div className="flex items-center flex-wrap gap-2 pt-3 min-h-[38px]">
            {item.categories?.length
              ? item.categories.map((category, index) => (
                <div
                  key={index}
                  className="rounded category-project-card"
                  style={{
                    background: "#F7F7F7",
                    padding: "4px 8px",
                  }}
                >
                  <p
                    style={{
                      color: "#7A7A7A",
                      fontSize: 12,
                      lineHeight: "18px",
                      fontWeight: 500,
                    }}
                  >
                    {category.name}
                  </p>
                </div>
              ))
              : null}
          </div>
          <div className="flex flex-wrap gap-2 items-end justify-between time-project-card mt-6">
            <div className="flex flex-col">
              <span className="text-[#7A7A7A] font-medium text-[12px] leading-[18px]">
                {item?.updated_at
                  ? `Edited ${formatDateForConversationMessage(
                    item.updated_at
                  )}`
                  : "No update"}
              </span>
              <span className="text-[#7A7A7A] font-medium text-[12px] leading-[18px]">
                {`Created date: ${formatDate(item.created_at, "DD MMM, yyyy")}`}
              </span>
            </div>

            {renderRoleUser()}
          </div>
          {isOrganization && item.group_organizations?.length ? (
            <div className="flex items-center gap-2 mt-[4px]">
              <span
                className="font-medium whitespace-nowrap"
                style={{
                  color: "#7A7A7A",
                  fontSize: 12,
                  lineHeight: "18px",
                }}
              >
                Assigned to:
              </span>
              <div className="flex items-center">
                {item.group_organizations.map((elGroup, index) => {
                  if (index + 1 > 6) {
                    return null
                  }
                  return (
                    <Tippy
                      key={index}
                      className="custom-tippy-menu-left"
                      placement="bottom"
                      content={
                        <p>
                          {elGroup.group_organization_id
                            ? `${elGroup.code} - ${elGroup.name}`
                            : `${elGroup.name} - ${elGroup.email}`}
                        </p>
                      }
                    >
                      <div
                        key={index}
                        className="flex items-center justify-center active-menu-left"
                        style={{
                          width: 24,
                          height: 24,
                          border: "1px solid #FFFFFF",
                          backgroundColor: elGroup.group_organization_id
                            ? "#FDBE4426"
                            : "#F7AC1B",
                          borderRadius: "50%",
                          marginLeft: index > 0 ? -8 : 0,
                        }}
                      >
                        {elGroup.group_organization_id ? (
                          <IconMenuGroup width={12} height={12} />
                        ) : (
                          <>
                            {elGroup.avatar ? (
                              <img
                                src={showImageUrl(
                                  elGroup.avatar,
                                  urlAvatar(elGroup.avatar)
                                )}
                                alt="avatar"
                                style={{
                                  borderRadius: "50%",
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                            ) : (
                              <p
                                style={{
                                  fontWeight: 500,
                                  fontSize: 11,
                                  lineHeight: "18px",
                                  color: "#FFF",
                                }}
                              >
                                {getFirstLetterInName(
                                  elGroup.name || "N/A",
                                  true
                                )}
                              </p>
                            )}
                          </>
                        )}
                      </div>
                    </Tippy>
                  )
                })}
                {item.group_organizations.length > 6 ? (
                  <div
                    className="flex items-center justify-center"
                    style={{
                      width: 24,
                      height: 24,
                      border: "1px solid #FFFFFF",
                      backgroundColor: "#7A7A7A",
                      borderRadius: "50%",
                      marginLeft: -8,
                    }}
                  >
                    <p
                      style={{
                        fontWeight: 500,
                        fontSize: 11,
                        lineHeight: "18px",
                        color: "#FFF",
                      }}
                    >
                      {`+${item.group_organizations.length - 6}`}
                    </p>
                  </div>
                ) : null}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  )
}
export default ProjectCard
